import { render, staticRenderFns } from "./SeminarTicket.vue?vue&type=template&id=8651f3a8&scoped=true&"
import script from "./SeminarTicket.vue?vue&type=script&lang=js&"
export * from "./SeminarTicket.vue?vue&type=script&lang=js&"
import style0 from "./SeminarTicket.vue?vue&type=style&index=0&id=8651f3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8651f3a8",
  null
  
)

export default component.exports